import api from "../api/axios";

export const getTripSheets = (params) => {
  if (typeof params === 'string' || !params) {
    return api.get(`/api/tripsheets/get-tripsheets`, { params: { branchCode: params } });
  }
  return api.get(`/api/tripsheets/get-tripsheets`, { params });
};

export const createTripSheet = (data) =>
  api.post("/api/tripsheets/create-tripsheet", data);

export const updateTripSheet = (id, data) =>
  api.put(`/api/tripsheets/update-tripsheets-status/${id}`, data);

export const getNextTripSheetNo = () =>
  api.get("/api/tripsheets/generate-next-tripsheet-no");
